import type { BrandSpecials } from '@iheartjane/data-access';
import { getApplicableGoldTagLabel } from '@iheartjane/menu';
import type { PriceId } from '@iheartjane/types';

import type { ProductSearchResultViewModel } from '@jane/bloom/viewModels/productSearch';

interface GetGoldLabelArgs {
  applicableBrandSpecialIds: number[];
  brandSpecials: BrandSpecials;
  lowestAvailablePriceVal?: string | null;
}

export function getGoldLabel({
  applicableBrandSpecialIds,
  brandSpecials,
  lowestAvailablePriceVal,
}: GetGoldLabelArgs): string | null {
  if (!applicableBrandSpecialIds.length || !brandSpecials.length) return null;

  return getApplicableGoldTagLabel({
    applicableBrandSpecialIds,
    brandSpecials,
    priceId: lowestAvailablePriceVal?.split('price_')[1] as PriceId | undefined,
  });
}

/**
 * TODO: collapse `getGoldLabel` into this; `bloomWizardModal` — its only
 * other caller — needs to pass `precalculatedShouldShowGold` and call this instead.
 * https://app.clickup.com/t/8407749/86bbfqqmw
 */
export function getGoldTagLabel(
  product: ProductSearchResultViewModel,
  brandSpecials: BrandSpecials
): string | null {
  if (!product.shouldShowGold || !product.applicable_brand_special_ids) {
    return null;
  }

  return getGoldLabel({
    applicableBrandSpecialIds: product.applicable_brand_special_ids,
    brandSpecials,
    lowestAvailablePriceVal:
      product.lowest_available_price && 'val' in product.lowest_available_price
        ? product.lowest_available_price.val
        : undefined,
  });
}
